<div class="container-fluid no-padding">
  <ng-content />
</div>
